(() => {
  const init = (root = document) => {
    const section = root.querySelector('[id$="__custom_content_KGdi8E"]');
    if (!section || section.dataset.ycVideoBound) return;
    const media = section.querySelector('video-element');
    const button = section.querySelector('.yc-video-toggle');
    if (!media || !button) return;
    section.dataset.ycVideoBound = 'true';
    const update = () => {
      const video = media.querySelector('video');
      const playing = video ? !video.paused : media.hasAttribute('playing');
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      if (video && !video.dataset.ycVideoBound) {
        video.dataset.ycVideoBound = 'true';
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
      }
    };
    button.addEventListener('click', () => {
      const video = media.querySelector('video');
      if (video) {
        if (video.paused) {
          media.paused = false;
          video.play().catch(() => update());
        } else {
          media.paused = true;
          video.pause();
        }
      } else {
        media.paused = false;
        media.play();
      }
    });
    media.addEventListener('click', (event) => {
      if (matchMedia('(max-width: 767.98px)').matches && event.target.tagName === 'IMG') {
        media.paused = false;
        media.play();
      }
    });
    new MutationObserver(update).observe(media, {childList: true, attributes: true, attributeFilter: ['loaded', 'playing']});
    update();
  };
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
